import { render, staticRenderFns } from "./onlineStudy.vue?vue&type=template&id=3d98c5a6&scoped=true&"
import script from "./onlineStudy.vue?vue&type=script&lang=js&"
export * from "./onlineStudy.vue?vue&type=script&lang=js&"
import style0 from "./onlineStudy.vue?vue&type=style&index=0&id=3d98c5a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d98c5a6",
  null
  
)

export default component.exports